import './styles/Sermons.css';
import axios from "axios";
import {useEffect, useState} from "react";
import VideoCard from "../components/VideoCard";
import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Grid from "@mui/joy/Grid";
import { Button } from '@mui/joy';
import { Link } from 'react-router-dom';

const Sermons = () => {
    const [feed, setFeed] = useState([]);
    const [loading, setLoading] = useState(false);
   

    useEffect(() => {
        // Feed
        axios.get("https://v1-izlbep32qq-uc.a.run.app/youtube")
            .then(response => {
                const videos = getXmlElementsByTag(response.data, 'entry');
                setFeed(videos);
                setLoading(true); 
            })
            .catch(error => console.error(error));
    }, []);

    function getXmlElementsByTag(xmlString, tagName) {
        if (typeof xmlString !== 'string') {
            throw new TypeError('xmlString must be a string.');
        }
        if (typeof tagName !== 'string') {
            throw new TypeError('tagName must be a string.');
        }

        try {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
            const parserError = xmlDoc.querySelector('parsererror');
            if (parserError) {
                console.error("XML Parsing Error:", parserError.textContent);
                return [];
            }
            const elements = xmlDoc.getElementsByTagName(tagName);
            return [...elements]; // Returns an empty array if no matching elements are found.

        } catch (error) {
            console.error("Error parsing XML:", error);
            return [];
        }
    }

    return (
        <Box className='App-header' textAlign='center'>
                <Box textAlign='center' sx={{backgroundColor: '#006494', marginTop: 2, height: '30vh', width: '100%'}}>
                    <Box sx={{padding: "4%"}}>
                        <Stack direction='column' className='elder-container' spacing={2}>
                            <Typography level='h1' sx={{ color: '#fff'}}>
                                Sermons
                            </Typography>
                            <Typography sx={{ color: '#fff'}}>
                            We’re always grateful to see you in person, as your presence brings life to our gatherings. If you’re traveling or away for any reason, our live stream is available so you can stay connected and revisit services anytime.
                            </Typography>
                            {/* <Button>Youtube</Button> */}
                        </Stack>
                    </Box>
                </Box>
            <Box className='sermon-container'>
                <Stack className='elder-container' spacing={2} sx={{marginTop: 10, display: {md: 'flex', xs: 'none'}}}>
                        <Typography level='h1'>
                                    Most Recent Sermon
                                </Typography>
                            { !loading ?
                                    (<p>The feed was not found.</p>)
                                    :
                                <iframe 
                                    className='recentSermon'
                                    src={`https://www.youtube.com/embed/${feed[0].childNodes[3].textContent}?si=rKkUTvDEVhCWrqcV?&autoplay=1&rel=0`}
                                    title="YouTube video player" 
                                    frameborder="0" 
                                    allow="accelerometer; 
                                    autoplay;
                                    clipboard-write; 
                                    encrypted-media; 
                                    gyroscope; 
                                    picture-in-picture; 
                                    web-share" allowfullscreen="allowfullscreen"></iframe>
                                }
                </Stack>
                <Stack className='elder-container' spacing={2} sx={{marginTop: 10, display: {md: 'none', xs: 'flex'}}}>
                        <Typography level='h1'>
                                    Most Recent Sermon
                                </Typography>
                            { !loading ?
                                    (<p>The feed was not found.</p>)
                                    :
                                <iframe 
                                    className='smallRecentSermon'
                                    src={`https://www.youtube.com/embed/${feed[0].childNodes[3].textContent}?si=rKkUTvDEVhCWrqcV?&autoplay=1&rel=0`}
                                    title="YouTube video player" 
                                    frameborder="0" 
                                    allow="accelerometer; 
                                    autoplay;
                                    clipboard-write; 
                                    encrypted-media; 
                                    gyroscope; 
                                    picture-in-picture; 
                                    web-share" allowfullscreen="allowfullscreen"></iframe>
                                }
                </Stack>
                <Typography level='h2' sx={{marginTop: 10, marginBottom: 4}}>Recent Sermons</Typography>
                <Grid className='elder-container' container spacing={6}>
                    { !loading ?
                        (<p>The feed was not found.</p>)
                        :
                        (feed.slice(0,6).map(video => (
                            <Grid size={2}>
                                <VideoCard info={video.childNodes} />
                            </Grid>
                        )))
                    }
                </Grid>
            </Box>
            <Box textAlign='center' sx={{backgroundColor: '#006494', marginTop: 2, height: '30vh', width: '100%'}}>
                <Box sx={{padding: "4%"}}>
                    <Stack direction='column' spacing={2} alignItems='center'>
                        <Typography sx={{ color: '#fff'}} level="h1">Looking for more?</Typography>
                        <Typography sx={{ color: '#fff'}}>Check out all the of the past live streams on our YouTube Channel.</Typography>
                        <Link to='https://www.youtube.com/@newhorizonvineyardchurch4635' text='Connect'>
                            <Button sx={{backgroundColor: 'white', fontSize: 'large',color: 'black','&:hover': 
                            {
                                color: "white",
                                backgroundColor:'gray'
                            },
                            }} variant='solid'>
                                YouTube
                            </Button>
                        </Link>
                    </Stack>
                </Box>
           </Box>
        </Box>
    );
};

export default Sermons;